var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _c(
      "div",
      { staticClass: "dropzone-container bg-white", attrs: { id: _vm.formId } },
      [
        _c(
          "form",
          {
            staticClass: "dropzone needsclick dz-clickable",
            attrs: { action: "", enctype: "multipart/form-data" }
          },
          [
            _vm.isParamSet
              ? _c("input", {
                  attrs: { type: "hidden", name: _vm.paramInput },
                  domProps: { value: _vm.paramValue }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.isParamSet2
              ? _c("input", {
                  attrs: { type: "hidden", name: _vm.paramInput2 },
                  domProps: { value: _vm.paramValue2 }
                })
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "dz-message needsclick text-center" }, [
              _c("span", { staticClass: "fas fa-cloud-upload-alt" }),
              _vm._v(
                "\n        " + _vm._s(_vm.$t("txtDropFileHere")) + "\n      "
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "file-list" })
          ]
        ),
        _vm._v(" "),
        _c("ul", { staticClass: "media-list list-unstyled" })
      ]
    ),
    _vm._v(" "),
    _c(
      "script",
      { attrs: { id: "default-media-upload-template", type: "text/template" } },
      [
        _vm._v(
          '\n    <li class="media media-upload mb-2 pb-2">\n      <div class="media-thumbnail">\n        <i class="fas fa-file-upload"></i>\n        <img data-dz-thumbnail />\n      </div>\n      <div class="media-body">\n        <div class="d-flex">\n          <p class="m-0" data-dz-name></p>\n          <a href="#" class="close ml-auto" data-dz-remove>&times;</a>\n        </div>\n\n        <p class="text-muted m-0" data-dz-size></p>\n        <p class="status m-0"\n           data-dz-error-message\n           data-queue="In queue"\n           data-uploading="Uploading..."\n           data-success="Upload was successful"\n           data-error="Failed to upload media.">\n          <span data-dz-errormessage></span>\n        </p>\n        <div class="progress">\n          <div class="progress-bar" role="progressbar" data-dz-uploadprogress></div>\n        </div>\n      </div>\n    </li>\n  '
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }